module.exports = __webpack_public_path__ + "img/Shawn_Huynh.2b3eb33c.jpg";